import axios from 'axios';

const TOKEN_KEY = "formlyze_admin_token";
const USER_KEY = "formlyze_admin_user";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Auto-logout only when a stored session token has expired/become invalid.
// Never intercept the login endpoint itself (wrong credentials also return 401).
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const isLoginRequest = error.config?.url?.includes("/admin/login");
        const hasStoredToken = !!localStorage.getItem(TOKEN_KEY);

        if (error.response?.status === 401 && !isLoginRequest && hasStoredToken) {
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export { TOKEN_KEY };
export default api;
